class ServicePermissionError extends Error {
  constructor (permission) {
    super(permission);
    this.name = this.constructor.name;
  }
}


export {ServicePermissionError};
